import { i18next, transliteration } from '@yola/ws-sdk';
import getLanguageCodes from 'src/js/modules/website-settings/helpers/get-language-codes';
import common from '../constants/common';

const validatePageName = (value) => {
  if (!value) {
    return i18next.t('Page name should not be empty');
  }

  const languageCodes = getLanguageCodes();

  if (languageCodes.includes(transliteration.slugify(value))) {
    return i18next.t('Page name cannot contain only language code (en, fr, de, etc)');
  }

  const includeNumberOrString = value.match(common.LETTER_OR_NUMBER_REGEXP);

  if (!includeNumberOrString) {
    return i18next.t('Page name must contain at list one letter or one number');
  }

  if (value.length > common.MAX_PAGE_NAME_LENGTH) {
    return i18next.t('Max length should be 70 characters.');
  }

  return null;
};

export default validatePageName;
